<script>
import router from "@/router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {useStore} from "vuex";

export default {
  name: "SplashPage",
  setup() {

    let store = useStore()
    let version_user = '1.0.2'
    let uid = localStorage.getItem('uid')

    if (uid !== null) {
      check_user_version()
    } else {
      new_user()
    }

    function check_user_version() {
      FreeWorld.Heisenberg({action: 'version_user'}, 'public_info').then((res) => {
        if (res.data !== version_user) {
          Swals.NewVersion()
          return false
        }

        FreeWorld.Heisenberg({action: 'updating_user'}, 'public_info').then((res) => {

          if (res.data == 1) {
            Swals.Updating();
            return false
          }

          if (FreeWorld.PinkMan(store.state.user_type, 'de') === 1) {
            runApp_user()
          } else {
            runApp_worker()
          }

        }).catch((res) => {
          Swals.Catch(res, check_user_version)
        })
      }).catch((res) => {
        Swals.Catch(res, check_user_version)
      })
    }

    function runApp_user() {
      FreeWorld.Heisenberg({action: 'city'}, 'public_info').then((res) => {

        store.commit('set_country', res.data)
        let country = res.data

        FreeWorld.Heisenberg({action: 'user_info'}, 'public_info', true).then((res) => {

          country.forEach((item) => {
            if (item.id === res.data.state_id) {
              res.data.state = item.name
              item.city.forEach((item_city) => {
                if (item_city.id === res.data.city_id) {
                  res.data.city = item_city.name
                  return false
                }
              })
            }
          })

          store.commit('set_profile', res.data)

          FreeWorld.Heisenberg({action: 'slider'}, 'public_info', true).then((res) => {

            store.commit('set_slider', res.data)

            FreeWorld.Heisenberg({action: 'tell'}, 'public_info').then((res) => {

              store.commit('set_info_support', res.data)

              FreeWorld.Heisenberg({action: 'adver_category'}, 'public_info').then((res) => {

                store.commit('set_category', res.data)


                setTimeout(() => {
                  router.push({name: 'HomePage'})
                }, 3000)

              }).catch((res) => {
                Swals.Catch(res, check_user_version)
              })

            }).catch((res) => {
              Swals.Catch(res, check_user_version)
            })

          }).catch((res) => {
            Swals.Catch(res, check_user_version)
          })

        }).catch((res) => {
          Swals.Catch(res, check_user_version)
        })

      }).catch((res) => {
        Swals.Catch(res, check_user_version)
      })
    }

    function runApp_worker() {
      FreeWorld.Heisenberg({action: 'user_info'}, 'public_info', true).then((res) => {

        store.commit('set_profile', res.data)

        FreeWorld.Heisenberg({action: 'slider'}, 'public_info', true).then((res) => {

          store.commit('set_slider', res.data)


          FreeWorld.Heisenberg({action: 'city'}, 'public_info').then((res) => {

            store.commit('set_country', res.data)

            FreeWorld.Heisenberg({action: 'tell'}, 'public_info').then((res) => {

              store.commit('set_info_support', res.data)

                setTimeout(() => {
                  router.push({name: 'W_HomePage'})
                }, 3000)



            }).catch((res) => {
              Swals.Catch(res, check_user_version)
            })

          }).catch((res) => {
            Swals.Catch(res, check_user_version)
          })

        }).catch((res) => {
          Swals.Catch(res, check_user_version)
        })

      }).catch((res) => {
        Swals.Catch(res, check_user_version)
      })
    }

    function new_user() {
      FreeWorld.Heisenberg({action: 'city'}, 'public_info').then((res) => {

        store.commit('set_country', res.data)

        FreeWorld.Heisenberg({action: 'tell'}, 'public_info').then((res) => {

          store.commit('set_info_support', res.data)

          setTimeout(() => {
            router.push({name: 'AccessPage'})
          }, 3000)


        }).catch((res) => {
          Swals.Catch(res, check_user_version)
        })

      }).catch((res) => {
        Swals.Catch(res, check_user_version)
      })
    }

    return {}
  }
}
</script>

<template>

  <div class="bg-splash d-flex justify-content-evenly align-items-center flex-column" id="main">
    <img class="img_logo" src="../assets/img/logoapp.png" alt="">

    <div class="waviy">
      <span class="text-white" style="--i:1">S</span>
      <span class="text-white" style="--i:2">A</span>
      <span class="text-white" style="--i:3">N</span>
      <span class="text-white" style="--i:4">G</span>
      <span class="text-white" style="--i:5">I</span>
      <span class="text-white" style="--i:6">N</span>
      <span class="text-white" style="--i:7">-</span>
      <span class="text-white" style="--i:8">S</span>
      <span class="text-white" style="--i:9">A</span>
      <span class="text-white" style="--i:10">V</span>
      <span class="text-white" style="--i:11">A</span>
      <span class="text-white" style="--i:12">R</span>
      <span class="text-white" style="--i:13">A</span>
      <span class="text-white" style="--i:14">N</span>
      <span class="text-white" style="--i:15">.</span>
      <span class="text-white" style="--i:16">.</span>
      <span class="text-white" style="--i:17">.</span>
    </div>
  </div>

</template>

<style scoped>
.img_logo {
  width: 60%;
}

.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, .2));
  display: flex;
  flex-direction: row-reverse;
}

.waviy span {
  font-family: logo;
  position: relative;
  display: inline-block;
  font-size: 2rem;
  color: #fff;
  text-transform: uppercase;
  animation: waviy 1s infinite;
  animation-delay: calc(.05s * var(--i));
}

@keyframes waviy {
  0%, 40%, 100% {
    transform: translateY(0)
  }
  20% {
    transform: translateY(-20px)
  }
}

.bg-splash {
  background-image: linear-gradient(to bottom left, #46E2FF, #268EE0, #0335BE);
}
</style>